import React, { useEffect, useCallback, useState} from 'react';
import SamplesStreamExplorer from './SamplesStreamExplorer.js';
import PresetsExplorer from 'components/installation/PresetsExplorer.js';
import {
    setQuickAddSearchText,
    setMaximizeExplorer} from 'actions/index.js';
import {INSTRUMENT_RACK} from 'constants/track-types.js';
import {useDoubleClick} from "components/hooks/useDoubleClick.js";

import {connect} from 'react-redux';

const SidebarPresets = ({
    explorerMaximized,
    setSearchText,
    setMaximizeExplorer,
    sequencerEngine,
    numTracks,
    searchText,
    preset,
    selectedSteps,
    hasPreset,
    isPianoRoll,
    track
}) =>{ 
    let inner ='';
    let onDoubleClick = useDoubleClick(() => {
        setMaximizeExplorer(!explorerMaximized);
        setSearchText('');
    });

    useEffect(() => {
        setMaximizeExplorer(false);
    }, []);

    useEffect(() => {
        if (sequencerEngine.tracks.length === 0) {
            setMaximizeExplorer(false);
        }
    }, [sequencerEngine.tracks]);

    if (track === undefined || (track.instrument === undefined && track.tracks === undefined) || track.isFrozen || !preset ||( track.instrument && !hasPreset && track.sample)) {
        // if its not frozen
        if (track && !track.isFrozen) {
            inner = (
                <SamplesStreamExplorer isPianoRoll={isPianoRoll} track={track}/>
            );
        } else {
            return [];
        }
    } else {
        let type = track.instrument ? track.instrument.getInstrumentType() :
            track.getTrackType();
        inner = (
            <PresetsExplorer
              isPianoRoll={isPianoRoll}
              initialSize={18} track={track} content={track.preset} searchText={searchText} type={type}/>
        );
    }

    let className = "quick-presets";
    if (!isPianoRoll && selectedSteps && selectedSteps.filter(x => x && x.group).length > 0) {
        className += " hide";
    }
    return (
        <div
          onClick={onDoubleClick}
          className={className}>
          {inner}
        </div>);
}

const mapStateToProps = (state, props) => {
    let t = props.sequencerEngine.getSelectedTrack();
    let preset = t && t.preset;
    return {
        track: t,
        hasPreset: preset && preset.contentHash,
        defaultSample: t && t.sample,
        searchText: state.selector.quickAddSearchText,
        preset,
        selectedTrack: state.mix.selectedTrack,
        numTracks: props.sequencerEngine.tracks && props.sequencerEngine.tracks.length,
        isFrozen: t && t.isFrozen,
        selectedSteps: state.keyboard.selectedPianoRollSteps,
        explorerMaximized: state.selector.explorerMaximized
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setMaximizeExplorer: x => dispatch(setMaximizeExplorer(x)),
      setSearchText: x => dispatch(setQuickAddSearchText(x)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarPresets);
